import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  rootError: {
    flex: 0,
    flexDirection: 'row',
    backgroundColor: '#13223b',
    borderColor: 'red', 
    paddingVertical: 15,
    paddingHorizontal: 10,
    borderBottomWidth: 1,
    paddingBottom: 25,
  },
  rootWarning: {
    flex: 0,
    flexDirection: 'row',
    backgroundColor: '#13223b',
    borderColor: '#F4AA00', 
    paddingVertical: 15,
    paddingHorizontal: 10,
    borderBottomWidth: 1,
    paddingBottom: 25,
  },
  iconType: {
    flex: 0.2,
    justifyContent: 'flex-start',
  },
  typeMessage: {
    justifyContent: 'center',
    flex: 0.7,
  },
  closeMark: {
    justifyContent: 'center',
    flex: 0.1,
  },
  textContainer: {
    //flex: 0.9,
    justifyContent: 'center',
    marginLeft: 10,
    height: 130,
  },
  closeContainer: {
    //flex: 0.1,
    justifyContent: 'center',
    alignItems: 'center',
    height: 30,
    width: 30,
  },
});